import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css'; // ייבוא קובץ העיצוב החדש
import { Routes, Route } from "react-router-dom";




export default function Footer() {
  return (
    <footer className="site-footer" dir="rtl">
      {/* אזור הניווט הראשי */}
      <div className="footer-container">
        
        {/* עמודה 1: ניווט מהיר */}
    <div className="footer-column">
  <h3 className="footer-title">ניווט מהיר</h3>
  <ul className="footer-inline-list">

    <li><Link to="/"> עמוד הבית</Link> </li>
    <li><Link to="/OurServices">השירותים שלנו</Link></li>
    <li><Link to="/about">אודות</Link></li>
    <li><Link to="/SealingContractors">קבלני איטום</Link></li>
    <li><Link to="/WorksGallery">גלריית עבודות</Link></li>
    <li><Link to="/Choosing_a_company_for_abseiling_work">בלוג</Link></li>
    <li><Link to="/ContactSection2">צור קשר</Link></li>
    <li><Link to="/Privacy_Policy">מדיניות פרטיות</Link></li>

  </ul>
</div>
        {/* עמודה 2: השירותים שלנו */}
   <div className="footer-column">
  <h3 className="footer-title">השירותים שלנו</h3>
  <ul className="footer-inline-list">

    <li><Link to="/ServicesPage">איטום גגות</Link></li>
    <li><Link to="/Leak_detection">איתור נזילות</Link></li>
    <li><Link to="/Rooftarps">זיפות גגות</Link></li>
    <li><Link to="/Bituminoussheets">יריעות ביטומניות</Link></li>
    <li><Link to="/Working_at_Height">עבודה בגובה</Link></li>
    <li><Link to="/Sealingexteriorwalls">איטום קירות חיצוניים</Link></li>

  </ul>
</div>

        {/* עמודה 3: שירותים נוספים */}
   <div className="footer-column">
  <h3 className="footer-title">שירותים נוספים</h3>
  <ul className="footer-inline-list">

    <li><Link to="/Working_in_abseiling">עבודות סנפלינג</Link></li>
    <li><Link to="/Roofrepair">תיקון גגות</Link></li>
    <li><Link to="/Abseiling_sealing">איטום בסנפלינג</Link></li>
    <li><Link to="/BuildingRehabilitation">שיקום מבנים</Link></li>
    <li><Link to="/Waterproofingroofswithbituminoussheets">איטום ביריעות ביטומניות</Link></li>
    <li><Link to="/Hot_tar">זפת חם</Link></li>
    <li><Link to="/Roofwaterproofingsheets">יריעות איטום לגג</Link></li>
    <li><Link to="/Types_of_bituminous_sheets">סוגי יריעות ביטומניות</Link></li>

  </ul>
</div>

        {/* עמודה 4: פרטי קשר */}
        <div className="footer-column contact-column">
          <div><strong>כתובת:</strong> סומך 6, בני ברק</div>
          <div><strong>טלפון:</strong> 052-6422426</div>
          <div><a href="mailto:itumimbgvahim@gmail.com">itumimbgvahim@gmail.com</a></div>
          <div className="facebook-icon-wrapper">
            <a href="#" className="facebook-link">
              <svg className="facebook-svg" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773L19.5 12h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
          </div>
        </div>

      </div>

      {/* אזור זכויות יוצרים תחתון */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div>© 2026 כל הזכויות שמורות לאיטומים בגבהים - איטום גגות</div>
          <div className="footer-logo">
  <a href="https://siteb2b.co.il/" target="_blank" rel="noopener noreferrer">
    <img src="/logooo.png" alt="לוגו" />
  </a>
</div>
        </div>
      </div>
    </footer>
  );
}
